import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../actions/authentication_actions';
import Resources from '../../helpers/resources';
import { getValueFromQueryString } from '../../helpers/utils';

// Components
import TermsList from '../components/terms_list';
import Description from '../components/description';
import Animation from '../components/animation';
import Search from '../components/search';
import ListController from '../components/list_controller';
import Related from '../components/related';
import Logo from '../components/logo';

class MathAZ extends Component {
    componentDidMount() {
        // When the component is mounted, call the authentication to verify the authToken
        this.props.authenticate();
        const backUrl = getValueFromQueryString('backUrl');
        if (backUrl) {
            window.sessionStorage.setItem('RETURN_URL', backUrl);
            // Remove the backUrl parameter
            const url = new URL(window.location.href);
            url.searchParams.delete('backUrl');
            window.top.location = url;
        }
    }
    
    render() {
        return (
            <div>
                <Logo />
                <TermsList />
                <Description />
                <Animation />
                <Related />
                <ListController />
                <Search />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        avatarsState: state.avatarsState
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ...actions
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MathAZ);